// @core/api/endpoints/task/update_checklist_item.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskResponse,
  UpdateChecklistItemRequest,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Update checklist item
 * Updates a checklist item's text, assignee, or due date. Use ToggleChecklistItem to change completion status.
 */
export async function UpdateChecklistItem(
  task_id: string,
  checklist_id: string,
  item_id: string,
  data: UpdateChecklistItemRequest,
  options?: RequestOptions
): Promise<TaskResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/checklists/:checklist_id/items/:item_id`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  requestPath = requestPath.replace(':checklist_id', encodeURIComponent(checklist_id));
  requestPath = requestPath.replace(':item_id', encodeURIComponent(item_id));
  const requestOptions = options;
  return client.put<TaskResponse>(requestPath, data, requestOptions);
}
